import { useEffect } from 'react';

function ComponenteRedireccionador() {
  useEffect(() => {
    // Se ejecuta inmediatamente cuando el componente se monta
    window.location.replace('http://www.distribuidoramcd.com/Pedidos/formulario_login.php');
  }, []);

  return <p>Redirigiendo ...</p>;
}

export default ComponenteRedireccionador;